export const INPUT_STATUS = {
  DEFAULT: 'DEFAULT',
  FOCUSED: 'FOCUSED',
};
